'use client'

import { ImageWrapper } from '@/components/image'

export const PriceModelImage = ({ imageUrl, modelName }: { imageUrl: string | null; modelName: string }) => {
  if (!imageUrl) {
    return null
  }
  return (
    <span
      aria-hidden="true"
      className="flex size-12 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white"
    >
      <ImageWrapper
        image={imageUrl}
        origin="product-prices-model-picker"
        loadTime="lazy"
        sizingProps={{ minWidth: 48, maxWidth: 96, resolutionCount: 2, sizes: '48px', quality: '80' }}
        imgProps={{ alt: modelName, className: 'size-12 object-contain' }}
      />
    </span>
  )
}
